<script lang="ts">
    export let dictionarySearchInput: HTMLInputElement;
    function focusSearchInputOnKeyDown(event: KeyboardEvent) {
        const key = event.code || event.key;

        if (!event.target || event.target["nodeName"] !== "BODY") {
            return;
        }

        let isSingleCharacter = event.key && /^.$/u.test(event.key);

        if (event["isComposing"] || event.keyCode === 229) {
            return;
        }

        if (event.ctrlKey || event.metaKey) {
            return;
        }

        if (!isSingleCharacter) {
            if (key && !(key.startsWith("Key") || key.startsWith("Digit"))) {
                return;
            }
        }
        dictionarySearchInput.focus();
    }

    function onKeypress(event: KeyboardEvent) {
        // for characters that are printed with alt+ NUMPAD combination
        const key = event.code || event.key;
        if (
            key.startsWith("Alt") &&
            event.key != "Alt" &&
            event.key.length == 1 &&
            event.composed
        ) {
            dictionarySearchInput.focus();
        }
    }
</script>

<svelte:window
    on:keydown={dictionarySearchInput ? focusSearchInputOnKeyDown : null}
    on:keypress={dictionarySearchInput ? onKeypress : null}
/>
